import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectApiToken, ProjectApiTokenScopes } from '@shared/index';
import { JwtPayload } from 'jwt-decode';
import { firstValueFrom } from 'rxjs';
import { removeFromArray } from '@reflact/tsutil';

export type ProjectApiTokenInFrontend = (Omit<ProjectApiToken, 'token'> & JwtPayload)

@Injectable({
  providedIn: 'root'
})
export class ProjectApiTokenService {
  public apiTokens: ProjectApiTokenInFrontend[] = [];
  private _selectedProjectId: string = "";

  constructor(public http: HttpClient) {

  }

  public set selectedProjectId(id: string) {
    if (id != this._selectedProjectId) {
      this._selectedProjectId = id;
      this.apiTokens = [];
    }
  }

  public get selectedProjectId() {
    return this._selectedProjectId;
  }

  public async loadApiTokens(): Promise<void> {
    const result = await this.getApiTokens(this._selectedProjectId);
    this.apiTokens = result;
  }

  private async getApiTokens(projectId: string): Promise<ProjectApiTokenInFrontend[]> {
    const result = await firstValueFrom(this.http.get<ProjectApiTokenInFrontend[]>("/api/toolbox/project/apitoken/list/" + projectId));
    return result;
  }

  public async createApiToken(tokenName: string, scopes: ProjectApiTokenScopes[], expiresIn: string | number): Promise<{ tokenObject: ProjectApiTokenInFrontend, token: string }> {
    const reqBody: { token: { name: string, scopes: ProjectApiTokenScopes[] }, expiresIn: string | number } = {
      token: {
        name: tokenName,
        scopes: scopes
      },
      expiresIn
    };
    type resultType = { tokenObject: ProjectApiTokenInFrontend, token: string }
    const createdToken = await firstValueFrom<resultType>(this.http.post<resultType>("/api/toolbox/project/apitoken/add/" + this._selectedProjectId,
      reqBody
    ));

    this.apiTokens.push(createdToken.tokenObject);
    return createdToken;
  }

  public async deleteUserInList(tokenId: string): Promise<void> {
    await firstValueFrom(this.http.delete("/api/toolbox/project/apitoken/revoke/" + this._selectedProjectId + "/" + tokenId));
    removeFromArray(this.apiTokens, ((u) => u._id == tokenId));
  }
}
